"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordInput = void 0;
const React = require("react");
const react_1 = require("react");
const react_password_strength_bar_1 = require("react-password-strength-bar");
const ResetPasswordContext_1 = require("../../../../contexts/ResetPasswordContext");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "PasswordInput");
/**
 * Provides a password input.
 */
const PasswordInput = ({ value, onInputChange, disabled = false, placeholder = "*********", showStrength = false }) => {
    const { onForgotPassword } = (0, react_1.useContext)(ResetPasswordContext_1.ResetPasswordContext);
    return (React.createElement("div", { className: css("") },
        React.createElement("input", { "data-test": "input", type: "password", onChange: evt => onInputChange(evt.target.value), value: value || "", disabled: disabled, placeholder: placeholder }),
        showStrength && (React.createElement("div", { className: css("strengthMeter") },
            React.createElement(react_password_strength_bar_1.default, { password: value || "" }))),
        !!onForgotPassword && (React.createElement("p", null,
            React.createElement("small", null,
                React.createElement("a", { onClick: onForgotPassword }, "Forgot password?"))))));
};
exports.PasswordInput = PasswordInput;
//# sourceMappingURL=index.js.map